import { useEffect, useRef } from "react";

import { useAuth } from "../../../hooks/useAuth";
import { sendCoord } from "./channel";

/**
 * Monitors authentication state and broadcasts a session-ended message when
 * the user logs out or their session expires. Detects transitions from
 * authenticated to unauthenticated and notifies the viewer window.
 */
export function useSessionMonitor(): void {
  const auth = useAuth();
  const wasAuthenticatedReference = useRef(!!auth.isAuthenticated);

  useEffect(() => {
    const isCurrentlyAuthenticated = auth.isAuthenticated;
    const wasAuthenticated = wasAuthenticatedReference.current;

    if (wasAuthenticated && !isCurrentlyAuthenticated) {
      const message = {
        type: "session-ended" as const,
        reason: "logout" as const,
      };
      sendCoord(message);
    }

    wasAuthenticatedReference.current = isCurrentlyAuthenticated;
  }, [auth.isAuthenticated]);
}
